import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from '../../../../../../hooks';
import { useDeleteDynamicReport } from '../../../../../scheduled-reports/hooks/useDeleteDynamicReport';
import { mergeQueryParams } from '../../../../../taboola-common-frontend-modules/query-params';
import { urlDateParser } from '../../../../../taboola-common-frontend-modules/utils/urlUtils';
import { DATE_PRESET, END_DATE, REPORT_ID, START_DATE, useDateRange } from '../../hooks';
import ActionsCellRenderer from './ActionsCellRenderer';

export const DynamicReportsActionsCellRenderer = ({ data, ...rest }) => {
    const [, setDateRange] = useDateRange();
    const deleteReport = useDeleteDynamicReport();
    const navigate = useNavigate();
    const location = useLocation();
    const buttonConfigs = useMemo(
        () => [
            {
                onClick: () => {
                    setDateRange({
                        [START_DATE]: data.startDate && urlDateParser(data.startDate),
                        [END_DATE]: data.endDate && urlDateParser(data.endDate),
                        [DATE_PRESET]: data.dateRange,
                    });
                    navigate(`${location.pathname}${mergeQueryParams('', { [REPORT_ID]: data.id })}`);
                },
                iconLabel: 'edit-o',
                dataMetricComponent: 'EditActionButton',
            },
            {
                onClick: () => deleteReport(`${data.id}`, `${data.name}`),
                iconLabel: 'delete',
                dataMetricComponent: 'DeleteActionButton',
            },
        ],
        [location, navigate, data, deleteReport, setDateRange]
    );

    return <ActionsCellRenderer data={data} buttonConfigs={buttonConfigs} {...rest} />;
};
